import MasonryDescriptionContainer from "../../../components/miscellaneous/gallery/masonryDescription";

const MasonryDescription = () => {
  return <MasonryDescriptionContainer />
};

export default MasonryDescription;
